const redactorRoutes = [
];


export default redactorRoutes;
